export * from './general-medical-shortcut.component';
